import { CALENDAR_TYPES } from "../../constants/calendarConstants";

/**
 * Validates the local authority field on create/edit forms.
 */
export function validateLocalAuthorityId(value, values) {
  if (values.type == CALENDAR_TYPES.HOLIDAY.id) {
    if (!!value) {
      return "Must not have a local authority selected";
    }
  }

  if (values.type === CALENDAR_TYPES.EDUCATION.id) {
    if (!value?.trim()) {
      return "Must select a local authority";
    }
  }

  return null;
}

/**
 * Validates the start date field on create/edit forms.
 * Date values must be in the YYYY-MM-DD format.
 */
export function validateStartDate(value, values) {
  if (!value?.trim()) {
    return "Must pick a date";
  }

  if (values.endDate < value) {
    return "Cannot be ahead of end date";
  }

  return null;
}

/**
 * Validates the end date field on create/edit forms.
 * Date values must be in the YYYY-MM-DD format.
 */
export function validateEndDate(value, values) {
  if (!value?.trim()) {
    return "Must pick a date";
  }

  if (value < values.startDate) {
    return "Cannot be earlier than start date";
  }

  return null;
}
